import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Chip } from 'components/shared/Chip/Chip'
import { Table } from 'components/shared/Table/Table'

import styles from './ChipCell.module.scss'

export const ChipCell = ({ color, label, maxWidth, hasIncreasedHeight }) => (
  <Table.Cell type="body" {...{ maxWidth, hasIncreasedHeight }}>
    <Box
      align="center"
      className={styles.content}
      justify="center"
      tagName="span"
    >
      <Chip size="medium" variant="filled" {...{ color, label }} />
    </Box>
  </Table.Cell>
)
